export function initLinkedCheckboxes() {
	jQuery('.linked-checkboxes').each(function() {
		var container = jQuery(this);

		function syncByValue(value, checked) {
			container.find('input[value="' + value + '"]').prop('checked', checked);
		}

		// sync on load
		container.find('input').each(function() {
			if (jQuery(this).is(':checked')) {
				syncByValue(jQuery(this).val(), true);
			}
		});

		// sync on change
		container.on('change', 'input', function() {
			syncByValue(jQuery(this).val(), jQuery(this).is(':checked'));
		});
	});
}
